<template>
  <div>
    <b-field :label="label" class="is-relative">
      <input
        ref="placeSearchAutocomplete"
        placeholder="Where to?"
        class="input place-autocomplete"
        type="text"
        :value="location"
        @blur="autoFill"
      />
      <a @click="clearValue" class="clear-value-link">Clear</a>
    </b-field>
  </div>
</template>

<script>
import GoogleMapsService from '@/services/GoogleMapsService.js';

export default {
  name: "PlaceSearch",
  props: {
    label: String,
  },
  data: function() {
    return {
      placeTypes: [
        //'geocode',
        //'establishment'
      ],
      autocomplete: null,
    };
  },
  mounted() {
    // // console.log('PlaceSearch', 'mounted')

    // Load Google Maps API and then initialize autocomplete
    this.initializeGoogleServices();
  },
  methods: {
    async initializeGoogleServices() {
      try {
        // Ensure Google Maps API is loaded
        await GoogleMapsService.load();

        // Initialize autocomplete after API is loaded
        await this.loadGoogleAutocomplete();
      } catch (error) {
        console.error('Failed to load Google Maps services:', error);
      }
    },

    async loadGoogleAutocomplete() {
      try {
        // Get Places library through the hotelSearch store
        const placesLibrary = await this.$store.dispatch('hotelSearch/getPlacesLibrary');

        this.autocomplete = new placesLibrary.Autocomplete(
          this.$refs.placeSearchAutocomplete,
          { types: this.placeTypes }
        );

        this.autocomplete.setFields(["geometry", "formatted_address"]);
        this.autocomplete.addListener("place_changed", this.fillInAddress);
      } catch (error) {
        console.error('Failed to initialize Google Places Autocomplete:', error);
      }
    },

    fillInAddress() {
      const place = this.autocomplete.getPlace();
      if (!place || !place.geometry) {
        return;
      }

      const location = place.geometry.location;
      // // console.log(location.lat() + ', ' + location.lng())
      // // console.log(this.autocomplete.getPlace());

      // Handle both function and property access for lat/lng
      let lat, lng;
      if (typeof location.lat === 'function') {
        lat = location.lat();
        lng = location.lng();
      } else {
        lat = location.lat;
        lng = location.lng;
      }

      const loc = {
        lat: lat,
        lng: lng,
        name: place.formatted_address
      };
      this.$emit("locUpdate", loc);
    },

    clearValue() {
      // console.log('clear input')
      this.$refs.placeSearchAutocomplete.value = "";
      const loc = {};
      this.$emit("locUpdate", loc);
    },

    async autoFill() {
      const input = this.$refs.placeSearchAutocomplete.value;
      if (!input.trim()) {
        return;
      }

      try {
        // Ensure Google Maps API is loaded
        const google = await GoogleMapsService.getGoogleMaps();

        const geocoder = new google.maps.Geocoder();
        geocoder.geocode(
          {
            address: input,
          },
          (results, status) => {
            if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
              const place = results[0];
              const location = place.geometry.location;

              // Handle both function and property access for lat/lng
              let lat, lng;
              if (typeof location.lat === 'function') {
                lat = location.lat();
                lng = location.lng();
              } else {
                lat = location.lat;
                lng = location.lng;
              }

              const loc = {
                lat: lat,
                lng: lng,
                name: place.formatted_address
              };
              this.$emit("locUpdate", loc);
            }
          }
        );
      } catch (error) {
        console.error('Failed to geocode address:', error);
      }
    },
  },
  computed: {
    newHotelLocation() {
      let location = "";

      location = this.$attrs.value.city ? this.$attrs.value.city + ", " : "";
      location += this.$attrs.value.state ? this.$attrs.value.state + ", " : "";
      location += this.$attrs.value.countryName
        ? this.$attrs.value.countryName
        : "";

      return location;
    },
    location() {
      return this.$attrs.value.name
        ? this.$attrs.value.name
        : this.newHotelLocation;
    },
  },
};
</script>

<style scoped>
.clear-value-link {
  position: absolute;
  right: 0;
  color: #ccc;
  font-size: 12px;
  line-height: 40px;
  padding: 0 15px;
}

/* *, *::after, *::before {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
}

body {
  background-color: #dcdde1;
  color: #2f3640;
  padding: 3rem;
}

.search-location {
  display: block;
  width: 60vw;
  margin: 0 auto;
  margin-top: 5vw;
  font-size: 20px;
  font-weight: 400;
  outline: none;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 10px;
} */
</style>
